import { jsx, jsxs } from "react/jsx-runtime";

const k = { jsx, jsxs };

export function PageHeader({
  eyebrow: e,
  title: t,
  sub: n,
  actions: r,
}) {
  return (0, k.jsxs)(`div`, {
    className: `head`,
    children: [
      (0, k.jsxs)(`div`, {
        children: [
          (0, k.jsx)(`p`, { className: `eyebrow`, children: e }),
          (0, k.jsx)(`h1`, { children: t }),
          n && (0, k.jsx)(`p`, { children: n }),
        ],
      }),
      r && (0, k.jsx)(`div`, { className: `actions`, children: r }),
    ],
  });
}
